import { render, staticRenderFns } from "./UserSettings.vue?vue&type=template&id=e67cab82&scoped=true"
import script from "./UserSettings.vue?vue&type=script&lang=ts"
export * from "./UserSettings.vue?vue&type=script&lang=ts"
import style0 from "./UserSettings.vue?vue&type=style&index=0&id=e67cab82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67cab82",
  null
  
)

export default component.exports